import { TypographyOptions } from "@mui/material/styles/createTypography";
import { createTheme } from "@mui/system";
import palette from "./palette";

const basePaletteTheme = createTheme({
  palette: palette,
});

const typography: TypographyOptions = {
  h1: {
    fontFamily: "'Noto Serif', serif",
    fontWeight: "bold",
    fontSize: "2rem",
    fontStyle: "italic",

    color: basePaletteTheme.palette.primary.main,
  },
  h2: {
    fontFamily: "'Noto Serif', serif",
    fontStyle: "italic",
    fontWeight: "bold",
    fontSize: "1.8rem",
    color: basePaletteTheme.palette.primary.main,
  },
  button: {
    color: "#ffffff",
  },
};

export default typography;
